export default {
  // 客服資訊
  billList: [],
  billPaging: {
    currentPage: 1,
    npp: 25,
    totalPages: 1,
    totalEntries: null,
  },
  /* 預約單 */
  reserveList: [],
  reservePaging: {
    currentPage: 1,
    npp: 10,
    totalPages: 1,
    totalEntries: null,
  },
  reserveCount: 0,
  kw: '',
  /* radio選項 */
  picked: 0,
  task: 'all',
  lastUpdateTime: '',
  refreshClick: false /* 紀錄重新整理btn是否被點擊，若點擊須將地圖中心設置到cookie中的點位 */,
  // 語音switch
  switchSpeech: true,
  /* 叫車紀錄左下角的司機資訊 */
  driverInfo: {},
  /* 訂單詳細資料modal*/
  billModal: {},
  isModalOpen: false,
  /* 查看司機即時訊息modal*/
  isDriverMsgModalOpen: false,
  driverMsgModal: {
    list: [],
    paging: {
      currentPage: 1,
      nextPage: null,
      previousPage: null,
      totalPages: 1,
      perPage: 10,
      totalEntries: 1,
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/hailStateV2/state.js